import { useEffect, useMemo, useState } from "react";

import EbayUnlistedTable, {
  UNLISTED_LIST_MODE_TOGGLES,
} from "../../components/ebayListings/unlistedTable/EbayUnlistedTable";
import { UnlistedTableStats } from "../../components/ebayListings/unlistedTable/Stats/UnlistedTableStats";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { PageMode } from "../../models/PagedTable";

export default function EbayUnlisted() {
  const { setInfo } = usePageNameContext();

  const readyToListIndex = useMemo(
    () =>
      UNLISTED_LIST_MODE_TOGGLES.findIndex(
        (t) => t.pageMode === PageMode.UnlistedReadyToList
      ),
    []
  );

  const [listModeToggles, setListModeToggles] = useState<boolean[]>(
    () => new Array(UNLISTED_LIST_MODE_TOGGLES.length).fill(false) as boolean[]
  );

  const handleToggle = (i: number) => {
    setListModeToggles((prev) => {
      const next = [...prev];
      next[i] = !next[i];
      return next;
    });
  };

  const readyToListActive =
    readyToListIndex >= 0 ? Boolean(listModeToggles[readyToListIndex]) : false;

  const handleToggleReadyToList = () => {
    if (readyToListIndex >= 0) handleToggle(readyToListIndex);
  };

  useEffect(() => {
    setInfo({
      name: "eBay Unlisted Items",
      desc: "View and manage parts that aren't listed on eBay",
    });
  }, []);

  return (
    <div className="mt-2 flex flex-col gap-3">
      <UnlistedTableStats
        readyToListActive={readyToListActive}
        onToggleReadyToList={handleToggleReadyToList}
      />
      <EbayUnlistedTable
        listModeToggles={listModeToggles}
        onListModeToggle={handleToggle}
      />
    </div>
  );
}
